import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { AuthLanguageSwitcher } from '@app/shared/components/auth-language-switcher/auth-language-switcher';
import { AppIcon } from '@app/shared/controls/app-icon/app-icon';

@Component({
  selector: 'app-auth-layout',
  imports: [RouterOutlet, TranslatePipe, AuthLanguageSwitcher, AppIcon],
  templateUrl: './auth-layout.html',
  styleUrl: './auth-layout.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthLayout {
  protected readonly featureCards = [
    {
      icon: 'icon-ai-chat-solid.svg',
      titleKey: 'auth.layout.features.aiChat.title',
      textTopKey: 'auth.layout.features.aiChat.textTop',
      textBottomKey: 'auth.layout.features.aiChat.textBottom',
      width: 30,
      height: 30,
    },
    {
      icon: 'icon-speech-solid.svg',
      titleKey: 'auth.layout.features.speech.title',
      textTopKey: 'auth.layout.features.speech.textTop',
      textBottomKey: 'auth.layout.features.speech.textBottom',
      width: 30,
      height: 30,
    },
    {
      icon: 'icon-text-translate-solid.svg',
      titleKey: 'auth.layout.features.textTranslate.title',
      textTopKey: 'auth.layout.features.textTranslate.textTop',
      textBottomKey: 'auth.layout.features.textTranslate.textBottom',
      width: 30,
      height: 30,
    },
    {
      icon: 'icon-doc-collab-solid.svg',
      titleKey: 'auth.layout.features.docCollab.title',
      textTopKey: 'auth.layout.features.docCollab.textTop',
      textBottomKey: 'auth.layout.features.docCollab.textBottom',
      width: 30,
      height: 30,
    },
  ] as const;
}
